import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import Image from "react-bootstrap/esm/Image";
import Accordion from "react-bootstrap/Accordion";
import ListGroup from "react-bootstrap/ListGroup";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import { Play } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

function MusicTiles(props) {
  const [songListTime, setSongListTime] = useState([]);
  const navigate = useNavigate();
  const playSonglist = (e) => {
    navigate("/music/?playlist=" + e);
  };

  return (
    <Accordion>
      {props.music.map((music, x) => {
        let totalTime = 0;
        if (music.style === props.style) {
          return (
            <>
              <Accordion.Item eventKey={x} key={music.id}>
                <Accordion.Header>
                  <div style={{ marginRight: "30px", fontSize: "30px", padding: "5px" }}>
                    {music.title}
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      right: 75,
                      position: "absolute",
                    }}
                  >
                    <Button
                      onClick={() => playSonglist(music.id)}
                      key={music.id}
                      style={{fontSize: "30px"}}
                    >
                      Play Soundtrack <Play />
                    </Button>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div
                    style={{
                      border: "solid 1px #898989",
                      borderRadius: "20px",
                      padding: "25px",
                      marginBottom: "15px",
                      fontSize: "20px",
                    }}
                  >
                    {props.songs.map((e) => {
                      if (e.playlist === music.id) {
                        totalTime = totalTime + Math.floor(e.duration / 60);
                      }
                    })}
                    Description: <br /> {music.description} <br />
                    Total Time: {totalTime} minutes <br />
                    Genre: {music.genre}
                  </div>
                  <ListGroup as="ol" numbered>
                    {props.songs.map((e) => {
                      if (e.playlist === music.id) {
                        return (
                          <ListGroup.Item
                            key={e.id}
                            as="li"
                            className="d-flex justify-content-between align-items-start"
                            style={{ borderRadius: "20px", marginBottom: "10px", fontSize: "20px", padding: "10px" }}
                          >
                            <div
                              className="ms-2 me-auto"
                              style={{ width: "100%" }}
                            >
                              <div className="fw-bold">{e.title}</div>
                              <Row>
                                <Col
                                  style={{
                                    borderRadius: "20px",
                                    marginRight: "5px",
                                    fontSize: "20px",
                                  }}
                                >
                                  Artist: {e.artist}
                                </Col>
                                <Col
                                  style={{
                                    borderRadius: "20px",
                                    marginRight: "5px",
                                    fontSize: "20px",
                                  }}
                                >
                                  Duration: {Math.floor(e.duration / 60)}{" "}
                                  minutes
                                </Col>
                              </Row>
                            </div>
                          </ListGroup.Item>
                        );
                      }
                    })}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            </>
          );
        }
      })}
    </Accordion>
  );
}

export default MusicTiles;
